import React, {useState, useEffect} from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import moment from "moment-jalaali"


const DatePickerYearCustomize = (props) => {
        const [value, setValue] = useState("");


        const setValueFunction = (event) => {
            if(!event){
                if (props.HasManyInputData) {
                    props.HasManyInputData(props.index, props.HasManyKey, "");
                }
                setValue("")
                return
            }
            const newDate = event.setMonth(1).setDay(1)
            setValue(newDate)

            if (props.pageType === "create" || props.pageType === "edit") {
                if (event === null) {
                    if (props.HasManyInputData) {
                        props.HasManyInputData(props.index, props.HasManyKey, null);
                    } else {
                        const setDate = props.inputData;
                        setDate[props.keyItem] = null;
                        props.setInputData(setDate);
                    }
                } else {
                    if (props.HasManyInputData) {
                        props.HasManyInputData(props.index, props.HasManyKey, event.unix);
                    } else {
                        const setDate = props.inputData;
                        setDate[props.keyItem] = event.unix;
                        props.setInputData(setDate);
                    }
                }
            }
        }


        useEffect(() => {
            if (value === null) {
                return
            }
            if (value.month !== undefined && props.pageType === "search") {
                const stringDate = `${value.year}/${value.month.number}/${value.day}`;
                const keyValue = props.keyValue;
                let object = props.inputData;
                object[keyValue] = stringDate;
                props.setInputData(object);
            }
        }, [props, value]);

        useEffect(() => {
            if (props.pageType === "edit") {
                if (props.HasManyInputData) {
                    props.HasManyInputData(props.index, props.HasManyKey, props.editDataValue);
                    if ((props.editDataValue && props.editDataValue.length === 0) || props.editDataValue.length === 0) {
                        setValue("");
                        if(props.item.min){
                            setValue(props.item.min)
                        }
                    } else {
                        setValue(new Date(moment.unix(props.editDataValue)));
                    }
                }
            } else {
                if (props.editDataValue === null) {
                    setValue("");
                } else if (props.pageType === "create") {
                    if (props.HasManyInputData) {
                        props.HasManyInputData(props.index, props.HasManyKey, "");
                    } else {
                        let object = props.inputData;
                        object[props.keyItem] = Date.now();
                        props.setInputData(object);
                    }
                    // setValue(new Date(moment.unix(props.editDataValue)));
                }
            }

            const urlParams = new URLSearchParams(window.location.search);
            if (props.pageType === "search") {
                if(urlParams.get(props.keyValue) !== null){
                    setValue(new Date((moment(urlParams.get(props.keyValue), 'jYYYY/jM/jD').format('YYYY-M-D').split(" ")[0].split("-").join(","))))
                }else{
                    setValue("")
                }
            }
        }, []);

        return (
            <DatePicker
                value={value}
                calendar={persian}
                onlyYearPicker={true}
                format="YYYY"
                locale={persian_fa}
                required={true}
                currentDate={new Date()}
                minDate={props.item.min??""}
                maxDate={props.item.max??""}
                onChange={setValueFunction}
                inputClass={`w-full h-full pr-[10px] ${
                    props.item.disabled !== undefined || props.item.disabled
                        ? "bg-[#e9e9e9] cursor-not-allowed dark:bg-[#2B2B2B] text-edit_input_text_disabled dark:text-[#a8adc7]"
                        : "bg-white dark:bg-[#B5B5B5] text-edit_input_text "}`}
                containerClassName={`w-full px-2 h-full bg-[#000]}`}
                // onFocusedDateChange={changing}
                disabled={props.item.disabled}
            />
        );
    }
;

export default React.memo(DatePickerYearCustomize);
